import { MouseEvent, useCallback } from 'react';

import { toast } from '#/components/UnifiedRfqs/toast';
import { useRfqQuotesCanceler } from '@paradigm/features/src/unified-rfqs/ui/rfqs/hooks';
import { useGrfqRfq } from '@paradigm/features/src/unified-rfqs/ui/rfq-context';
import { unformatDecimal } from '@paradigm/utils/formatDecimal';
import { CrossButton } from '#/components/buttons/CrossButton';
import { useTrackAction } from '@paradigm/features/src/analytics';

interface Props {
  readonly title: string;
  readonly side: 'BUY' | 'SELL';
  /* if price is null the button kills all quotes from a given side */
  readonly price: string | null;
  disabled?: boolean;
}

export default function KillQuoteButton(props: Props) {
  const { title, side, disabled = false, ...restProps } = props;
  const price = props.price != null ? unformatDecimal(props.price) : null;

  const rfq = useGrfqRfq();
  const [{ isLoading }, cancel] = useRfqQuotesCanceler({
    rfqId: rfq.id,
    side,
    price,
  });

  const trackAction = useTrackAction();
  const handleClick = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      trackAction('kill quote', { side });
      event.stopPropagation();
      cancel(toast);
    },
    [cancel, side, trackAction],
  );

  return (
    <CrossButton
      {...restProps}
      title={title}
      onClick={handleClick}
      disabled={isLoading || disabled}
    />
  );
}
